import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  operationNumber: string;
}
const FlowTitleWarning: React.FC<Props> = ({ operationNumber }) => {
  const { t } = useTranslation();
  return (
    <h5 className="d-flex align-items-center">
      <FontAwesomeIcon color="#fab428" icon="exclamation-triangle" />
      <span className="ml-2" style={{ color: '#787985' }}>
        {t('warningRelatedFlowVersion', { operationNumber })}
      </span>
    </h5>
  );
};

export default FlowTitleWarning;
